import { Box } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';

const BetaTag = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      borderRadius: '2px',
      width: 'fit-content',
      paddingInline: '4px',
      height: '22px',
      backgroundColor: colors.grey[100],
    }}
  >
    <Typography variant="caption-bold" color={colors.grey[700]}>
      Beta
    </Typography>
  </Box>
);

export default BetaTag;
